import { Injectable } from '@angular/core';
import { AccountService } from '../auth/account.service';
import { LocalStorage } from '../auth/local.storage';
import { CloudAuthBaseService, CLOUD_PKCE_VERIFIER_KEY } from '../cloud-storage/cloud-auth-base.service';
import { CloudServiceEnum } from '../cloud-storage/enums';
import { WolandCloudDriveServerConnectionService } from './woland-cloud-drive-server-connection';

@Injectable({
    providedIn: 'root'
})
export class WolandBaseDriveAuthService extends CloudAuthBaseService {
    // TODO, make generic?
    // because there can only be one active cloud
    // no need to keep track of all in storage, right?
    private INFO_KEY = 'INFO_KEY_WOLAND';

    get wolandDriveInfo(): WolandCloudDriveAuthInfo | null {
        return this.localStorage.get<WolandCloudDriveAuthInfo>(this.getKey());
    }

    constructor(
        protected readonly localStorage: LocalStorage,
        protected readonly accountService: AccountService,
        protected readonly wolandCloudDriveServerConnectionService: WolandCloudDriveServerConnectionService,
    ) {
        super(localStorage);
    }

    async authorize(): Promise<void> {
        throw('authorize for woland drive auth not implemented');
    }

    async sendAutorizationCodetoServer(code: string, cloud: CloudServiceEnum) {
        const verifier = this.localStorage.get<string>(CLOUD_PKCE_VERIFIER_KEY) ?? undefined;
        this.localStorage.remove(CLOUD_PKCE_VERIFIER_KEY); // one-time use
        const info = await this.wolandCloudDriveServerConnectionService.requestToken(code, cloud, verifier);
        this.localStorage.set<WolandCloudDriveAuthInfo>(this.getKey(), info);
      }

    async unAttachDrive(): Promise<void> {
        throw('unattach drive for woland drive auth not implemented');
    }

    getScope(): string {
        throw('get scrope for woland drive auth not implemented');
    }

    async getDisplayName(): Promise<string | null> {
        const profile = this.wolandDriveInfo;
          if (profile !== null) {
            return profile.email ? profile.email : profile.userName;
          } else {
            return null;
          }
    }

    public setDriveInfo(userName: string, email: string, type: string): void {
        const cloudType = this.mapCloudStrToCloudEnum(type);
        let info = {
          userName: userName,
          email: email,
          cloudType : cloudType,
          scope: this.getScope()
        }
        this.localStorage.set<WolandCloudDriveAuthInfo>(this.getKey(), info as WolandCloudDriveAuthInfo);
    }

    logout(): void {
        this.localStorage.remove(this.getKey());
    }

    isConnected() {
        throw('isConnected for woland drive auth not implemented');
    }

    getKey(): string {
        const key = this.INFO_KEY + this.accountService.userId;

        // check if there is still some info left on the 'old' key
        const info = this.localStorage.get<WolandCloudDriveAuthInfo>(this.INFO_KEY);

        // if there is, remove it and save the info under the 'new' key
        if (info) {
          this.localStorage.remove(this.INFO_KEY);
          this.localStorage.set<WolandCloudDriveAuthInfo>(key, info as WolandCloudDriveAuthInfo);
        }

        // return the key
        return key;
    }

    private mapCloudStrToCloudEnum(type: string): CloudServiceEnum {
        switch (type) {
            case 'GoogleDrive': return CloudServiceEnum.GoogleDrive;
            case 'OneDrive': return CloudServiceEnum.OneDrive;
            case 'Dropbox': return CloudServiceEnum.DropBox;
            default:
                console.error('map cloud string to cloud enum, default: ', type);
                return CloudServiceEnum.CloudStorage;
        }
    }
}

export interface WolandCloudDriveAuthInfo {
    userName: string;
    email: string;
    cloudType: CloudServiceEnum;
  }
